import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=2f02b6dd&"
import script from "./Scene.vue?vue&type=script&lang=ts&"
export * from "./Scene.vue?vue&type=script&lang=ts&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=2f02b6dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports